(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-comparison-table"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var SELECTORS = [
      'product-form .product-form__submit',
      '.product-form__submit',
      'form[action*="/cart/add"] button[type="submit"]',
      'form[action*="/cart/add"] [name="add"]',
      'button[name="add"]',
      'product-form',
      'form[action*="/cart/add"]',
      '.product__info-wrapper',
    ];

    function findTarget(root, custom) {
      var list = custom ? [custom].concat(SELECTORS) : SELECTORS;
      for (var i = 0; i < list.length; i++) {
        var nodes;
        try {
          nodes = document.querySelectorAll(list[i]);
        } catch (e) {
          continue;
        }
        for (var j = 0; j < nodes.length; j++) {
          if (!root.contains(nodes[j]) && nodes[j].getClientRects().length) return nodes[j];
        }
      }
      return null;
    }

    function init(el) {
      if (el.getAttribute('data-rc-init')) return;
      el.setAttribute('data-rc-init', '1');

      var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var animate = el.getAttribute('data-animate') === 'true' && !reduced;

      if (!animate || !('IntersectionObserver' in window)) {
        el.classList.add('in-view');
      } else {
        el.classList.add('is-armed');
        var io = new IntersectionObserver(
          function (entries) {
            for (var i = 0; i < entries.length; i++) {
              if (entries[i].isIntersecting) {
                el.classList.add('in-view');
                io.disconnect();
                break;
              }
            }
          },
          { threshold: 0.15 }
        );
        io.observe(el);
      }

      var btn = el.querySelector('[data-scroll-to-cart]');
      if (!btn) return;
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var target = findTarget(el, btn.getAttribute('data-selector'));
        if (!target) return;
        var rect = target.getBoundingClientRect();
        var offset = parseInt(btn.getAttribute('data-offset'), 10) || 90;
        var y =
          rect.height < window.innerHeight * 0.5
            ? rect.top + window.pageYOffset - (window.innerHeight - rect.height) / 2
            : rect.top + window.pageYOffset - offset;
        window.scrollTo({ top: Math.max(y, 0), behavior: reduced ? 'auto' : 'smooth' });
        setTimeout(function () {
          try {
            target.focus({ preventScroll: true });
          } catch (err) {}
        }, 700);
      });
    }

    function initAll(scope) {
      (scope || document).querySelectorAll('.rcmp').forEach(init);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        initAll();
      });
    } else {
      initAll();
    }
    document.addEventListener('shopify:section:load', function (e) {
      initAll(e.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
